import { map, of, switchMap, type Observable } from 'rxjs';
import evalAuthorization from 'utils/rxjs/eval-authorization';
import is from 'utils/is';
import type { RouteAuthorization } from 'contracts';
import user from 'store/user';
import performer from 'store/performer';
import moduleAuth from 'store/module-authorization';

import id from './id';

const authorization: RouteAuthorization = {
  name: id,
  authorization$: () =>
    user.onChange$.pipe(
      evalAuthorization(
        ({ viewTypeId }) => is.nullish(viewTypeId),
        (): Observable<boolean> => {
          if (user.isStudioView() || user.isLimitedStudioAccountType()) {
            return of(false);
          }

          return performer.onChange$.pipe(
            map((performerData) => !user.isImpersonating(performerData.personIds)),
            switchMap((canAccess): Observable<boolean> => {
              if (!canAccess) return of(false);

              return of(
                moduleAuth.hasServicesAgreementPermission() || moduleAuth.hasServicesAgreementGracePeriodPermission()
              );
            })
          );
        }
      )
    ),
};

export default authorization;
